import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DeliveryNoteHandlingUnitSearchCriteria, DeliveryNoteParams } from '../../../models';
import { getQueryStringFromObject } from '../../../../../../common/utils';
import { DeliveryNoteEndpoint } from '../../../constants/delivery-note-endpoint';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../../services/config';
import { DeliveryNoteHandlingUnitsStateModel } from './delivery-note-handling-units.state';

@Injectable({
  providedIn: 'root',
})
export class DeliveryNoteHandlingUnitsService {
  constructor(private http: WrapperHttpService) {}

  getHandlingUnits(
    { deliveryNoteNumber, sapId }: DeliveryNoteParams,
    searchCriteria: DeliveryNoteHandlingUnitSearchCriteria,
  ): Observable<DeliveryNoteHandlingUnitsStateModel> {
    const url =
      `${API_URL}${DeliveryNoteEndpoint.Base}${DeliveryNoteEndpoint.Monitoring}${DeliveryNoteEndpoint.DeliveryNote}/${deliveryNoteNumber}${DeliveryNoteEndpoint.HandlingUnits}?` +
      getQueryStringFromObject({ sapId, ...searchCriteria });
    return this.http.withLoading().get<DeliveryNoteHandlingUnitsStateModel>(url);
  }
}
